import { filter, map, switchMap } from 'rxjs/operators';
import { DbService } from './../../services/db.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(
    public db: DbService
  ) { }

  ngOnInit(): void {
    localStorage.removeItem('gamestop');
  }

}
